/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AppendContactsCompanyResponseData,
  AppendContactsCompanyResponseDataFromJSON,
  AppendContactsCompanyResponseDataFromJSONTyped,
  AppendContactsCompanyResponseDataToJSON
} from './AppendContactsCompanyResponseData'

/**
 *
 * @export
 * @interface AppendContactsCompanyResponse
 */
export interface AppendContactsCompanyResponse {
  /**
   *
   * @type {number}
   * @memberof AppendContactsCompanyResponse
   */
  status?: number
  /**
   *
   * @type {AppendContactsCompanyResponseData}
   * @memberof AppendContactsCompanyResponse
   */
  data?: AppendContactsCompanyResponseData
}

export function AppendContactsCompanyResponseFromJSON(json: any): AppendContactsCompanyResponse {
  return AppendContactsCompanyResponseFromJSONTyped(json, false)
}

export function AppendContactsCompanyResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendContactsCompanyResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : AppendContactsCompanyResponseDataFromJSON(json['data'])
  }
}

export function AppendContactsCompanyResponseToJSON(value?: AppendContactsCompanyResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: AppendContactsCompanyResponseDataToJSON(value.data)
  }
}
